module.exports = __webpack_public_path__ + "img/albania.e34fcf2b.svg";